import { useState } from "react";
import { CreateUserForm } from "./CreateUserForm";
import { UsuariosList } from "./UsuariosList";
import { UserDetails } from "./UserDetails";
import { useAdminPanelUI } from "../../hooks/useAdminPanelUI";

export enum UserActions {
    UserList = "UserList",
    UserCreateForm = "UserCreateForm",
    UserDetails = "UserDetails",
}

export function UserActionsContainer() {
    const [userSelectedId, setUserSelectedId] = useState(0);

    const { userActions } = useAdminPanelUI();

    const actions = {
        "UserList": <UsuariosList 
            setUserSelected={setUserSelectedId} />,
        "UserCreateForm": <CreateUserForm />,
        "UserDetails": <UserDetails
            userId={userSelectedId} />
    }

    const currentAction = actions[userActions];

    return (
        <div className="h-full w-full">
            {currentAction}
        </div>
    );
}